import { ecClientApi } from "../service";
import ApiRoutes from "../constants/api-routes";
import { getSessionId } from "../utils/auth";

// Builds the X-Session-Id header for every cart request
// ecClientApi (axios) already attaches Bearer token via interceptor,
// so we only need to add the session header on top
const cartHeaders = () => ({
  headers: { "X-Session-Id": getSessionId() },
});

// ── Add item to cart ───────────────────────────────────────────
// body: { product_id: string, quantity: number }
export const addToCart = async (body) => {
  try {
    const response = await ecClientApi.post(
      ApiRoutes.CREATE_CART,
      body,
      cartHeaders(),
    );
    return response;
  } catch (error) {
    console.error("Error adding to cart:", error);
    throw error;
  }
};

// ── Get cart (guest or logged-in) ──────────────────────────────
export const getCart = async () => {
  try {
    const response = await ecClientApi.get(ApiRoutes.GET_CARTS, cartHeaders());
    return response;
  } catch (error) {
    console.error("Error fetching cart:", error);
    throw error;
  }
};

// ── Update item quantity ───────────────────────────────────────
// body: { quantity: number }
export const updateCartItem = async (productId, body) => {
  try {
    const response = await ecClientApi.put(
      ApiRoutes.UPDATE_CART + productId,
      body,
      cartHeaders(),
    );
    return response;
  } catch (error) {
    console.error("Error updating cart item:", error);
    throw error;
  }
};

// ── Remove a single item ───────────────────────────────────────
export const removeCartItem = async (productId) => {
  try {
    const response = await ecClientApi.delete(
      ApiRoutes.REMOVE_CART_ITEM + productId,
      cartHeaders(),
    );
    return response;
  } catch (error) {
    console.error("Error removing cart item:", error);
    throw error;
  }
};

// ── Clear all items from cart ──────────────────────────────────
export const clearCart = async () => {
  try {
    const response = await ecClientApi.delete(
      ApiRoutes.CLEAR_CART,
      cartHeaders(),
    );
    return response;
  } catch (error) {
    console.error("Error clearing cart:", error);
    throw error;
  }
};

// ── Merge guest cart after login ───────────────────────────────
// Call this once immediately after login succeeds
export const mergeCart = async () => {
  try {
    const response = await ecClientApi.post(
      ApiRoutes.MERGE_CART,
      {}, // no body needed
      cartHeaders(), // sends both Bearer token (from interceptor) + session ID
    );
    return response;
  } catch (error) {
    console.error("Error merging cart:", error);
    throw error;
  }
};
